// Application Shell
import {Shell} from '@/entryPoints/b2c/shell';

// Legacy Plugins
import '@/vendor/owl.carousel.min.js';
import '@/vendor/owl.carousel.plugins.js';
import '@/vendor/jquery.magnific-popup.min';

// Legacy Modules
import slider from '@/modules/slider';
import player from '@/modules/Players';
import productTile from '@/modules/ProductTile';
import videoBackground from '@/modules/VideoBackground';

// Styling
import '@sassRoot/entryPoints/b2c/homepage.scss';

import ProductTile from '@/components/containers/plp/ProductTile.vue';

class Homepage extends Shell {
  loadPlugins() {
    super.loadPlugins();
  }
}

const homepage = new Homepage({ProductTile});
homepage.preLoadInits();
homepage.initializeVue();

// Legacy foundation initialization
$(document).foundation();

$(document).ready(() => {
  homepage.globalDocumentReadyInits();

  // Videos
  player();

  if ($('[data-bg-video]').length) {
    videoBackground($('[data-bg-video]'));
  }

  // setting up owl sliders
  const sliders = $('[data-owl-slider]');
  window.sliderRefs = [];
  sliders.each((i, s) => {
    window.sliderRefs.push(slider($(s)));
  });

  // Color Swatches for carousels (More Options, etc)
  if ($('.product-tile').length) {
    productTile($(document));
  }
});

$(window).on('load', () => {
  homepage.globalOnLoadInits();
});
